import { motion } from "framer-motion";

// Lightweight scroll-reveal wrapper using framer-motion whileInView.
export const Reveal = ({ children, delay = 0, y = 24, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, delay, ease: [0.4, 0, 0.2, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, subtitle, className = "" }) => (
  <div className={`max-w-2xl ${className}`}>
    {eyebrow && (
      <span
        className="inline-block text-xs font-bold uppercase tracking-[0.18em] text-brand-green mb-3"
        data-testid="section-eyebrow"
      >
        {eyebrow}
      </span>
    )}
    <h2 className="text-3xl md:text-[44px] leading-[1.15] font-bold text-brand-navy">
      {title}
    </h2>
    {subtitle && (
      <p className="mt-4 text-base md:text-lg leading-[1.8] text-slate-500">
        {subtitle}
      </p>
    )}
  </div>
);
